var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"menu"}},_vm._l((_vm.items),function(item,index){return _c('BaseSidebarItem',{key:index,attrs:{"should-focus":!index,"selected":_vm.isSelected(item),"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }